import { render, staticRenderFns } from "./MetadataVersionHistory.vue?vue&type=template&id=0f3c588b&scoped=true"
import script from "./MetadataVersionHistory.vue?vue&type=script&lang=js"
export * from "./MetadataVersionHistory.vue?vue&type=script&lang=js"
import style0 from "./MetadataVersionHistory.vue?vue&type=style&index=0&id=0f3c588b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3c588b",
  null
  
)

export default component.exports